(function ($) {
    $(document).ready(function () {
        if ($('.testimonial-slider').length > 0) {
            if ($(".testimonial-slider .img-wrap img").length <= 0) {
                $(".testimonial-slider").addClass("no-image");
            }
            if ($(".testimonial-slider .slide").length > 1) {
                //$(".testimonial-slider .arrow-btns").css("display", "none");
                $('.testimonial-slider .slide-wrapper').slick({
                    infinite: false,
                    slidesToShow: 1,
                    slideToScroll: 1,
                    adaptiveHeight: true,
                    prevArrow: $('.testimonial-slider .arrow-prev'),
                    nextArrow: $('.testimonial-slider .arrow-next')
                });
            }
            $('.testimonial-slider .slide').css('opacity', '1');
        }
    });

})(jQuery);